import { ApiError } from '../client';
import { getNonCollectDeliveryMockError, markDeliveryNonCollectedInMock } from './deliveryDetail';

// Mock of the empty-pickup WRITE: simulate latency, then either reject with an injected backend
// error (dev/test hook for the generic-error banner) or flip the delivery to non_collected in the
// shared detail mock, so a follow-up fetchDeliveryDetailMock returns the new state. Idempotent.
export async function nonCollectDeliveryMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const injected = getNonCollectDeliveryMockError();
  if (injected !== null) {
    throw new ApiError(409, injected, { code: injected }, `non-collect failed: ${injected}`);
  }
  markDeliveryNonCollectedInMock(id);
}
